import { find } from 'lodash';

export default class ZipUtils {
    static getCountryAndStateByCity(value, zipData) {
        return find(zipData, { city: value }) || {};
    }
}
